import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import * as View from './index.component';

export const routes: Routes = [

    { path: '', component: View.IndexComponent }

];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/home/home.routing.module.ts